import React, { useEffect, useState } from "react";
import "../styles/PatientAdress.css";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
//import SymptomCalculator from "./Patient UI/SymptomCalculator"; //changes by nanda
import IntakeForm from "./Patient UI/IntakeForm";
const Patientaddress = (props) => {
  // console.log(typeof(props));
  const receivedProps = props;
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [open, setOpen] = useState(false);
  console.log(props.data);
  //const [intakeForm, setInTakeForm] = useState(true);
  const onsubmit = (values) => {
    const allData = Object.assign(values, props.data);
    console.log("All data:", allData);
    props.step2Data(allData); //will send the data to parent comp i.e. sign up for my self
  };

  // document.addEventListener('keydown', (event) => {
  //   if (event.keyCode === 13) {
  //     event.preventDefault();
  //     console.log('Enter key pressed');
  //     handleSubmit(onsubmit)();
  //   }
  // });

  return (
    <form class="PatientAddress-container" onSubmit={handleSubmit(onsubmit)}>
      <h1>youro</h1>
      <p className="h3">
        If in-person visits are best for you we will seamlessly
        <br /> transition your care to one of our urology partners in
        <br />
        your area.
      </p>
      <div className="Form-address-Container">
        <div className="address-fields">
          <div className="label-address">
            {/* <label>Address</label> */}
            <input
              placeholder="Address *"
              className="input-field input-border"
              type="text"
              {...register("address", {
                required: true,
                maxLength: 50,
              })}
            />
            {errors?.address?.type === "required" && (
              <p className="error-text">This field is required</p>
            )}
            {errors?.address?.type === "maxLength" && (
              <p className="error-text">Address cannot exceed 40 characters</p>
            )}
          </div>

          <div className="label-address">
            <input
              placeholder="City *"
              className="input-field input-border"
              type="text"
              {...register("city", {
                required: true,
                maxLength: 32,
              })}
            />
            {errors?.city?.type === "required" && (
              <p className="error-text">This field is required</p>
            )}
            {errors?.city?.type === "maxLength" && (
              <p className="error-text">
                Last Name cannot exceed 32 characters
              </p>
            )}
          </div>

          {/* <div className="label-address">
            <input
              placeholder="State *"
              className="input-field input-border"
              type="text"
              {...register("state", {
                required: true,
                maxLength: 32,
              })}
            />
            {errors?.state?.type === "required" && (
              <p className="error-text">This field is required</p>
            )}
            {errors?.state?.type === "maxLength" && (
              <p className="error-text">Email cannot exceed 32 characters</p>
            )}
          </div> */}
          <div className="label-address">
            <select className="input-field input-border" {...register("state", {required: true})}>
              <option value="">Select a State *</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
            {errors?.state?.type === "required" && <p className="error-text">This field is required</p>}
          </div>

          {/*<div className="label-address">*/}
          {/*  <input*/}
          {/*    placeholder="zipcode *"*/}
          {/*    className="input-field input-border"*/}
          {/*    type="text"*/}
          {/*    {...register("zipCode", {*/}
          {/*      required: true,*/}
          {/*      maxLength: 5,*/}
          {/*    })}*/}
          {/*  />*/}
          {/*  {errors?.zipCode?.type === "required" && (*/}
          {/*    <p className="error-text">This field is required</p>*/}
          {/*  )}*/}
          {/*  {errors?.zipCode?.type === "maxLength" && (*/}
          {/*    <p className="error-text">Zip code cannot exceed 5 characters</p>*/}
          {/*  )}*/}
          {/*</div>*/}
          <div className="label-address">
            <input
                placeholder="zipcode *"
                className="input-field input-border"
                type="text"
                maxLength={5} // Limit input to 5 characters
                pattern="[0-9]*" // Allow only digits
                onInput={(e) => {
                  // Replace non-digit characters
                  e.target.value = e.target.value.replace(/\D/g, '');
                }}
                {...register("zipCode", {
                  required: true,
                  maxLength: {
                    value: 5,
                    message: "Zip code cannot exceed 5 characters",
                  },
                  minLength: {
                    value: 5,
                    message: "Zip code must be exactly 5 characters",
                  },
                })}
            />
            {errors?.zipCode && (
                <p className="error-text">
                  {errors.zipCode.message}
                </p>
            )}
          </div>

          <p></p>
          <div className="label-address">
            <label>Date of Birth</label>
            <input
              placeholder="YYYY-MM-DD"
              className="input-field input-border"
              type="date"
              {...register("dateOfBirth", {
                required: true,
                maxLength: 32,
              })}
            />
            {errors?.dateOfBirth?.type === "required" && (
              <p className="error-text">This field is required</p>
            )}
            {errors?.dateOfBirth?.type === "maxLength" && (
              <p className="error-text">Email cannot exceed 32 characters</p>
            )}
          </div>

          <p></p>
          <div className="address-fields">
            <div className="label-address">
              <label>Legal Sex</label>
              <div>
                <input
                  {...register("gender", { required: true })}
                  type="radio"
                  value="MALE"
                />
                Male
              </div>
              <div>
                <input
                  {...register("gender", { required: true })}
                  type="radio"
                  value="FEMALE"
                />
                Female
              </div>
              <div>
                <input
                    {...register("gender", {required: true})}
                    type="radio"
                    value="OTHER"
                />
                Prefer not to specify
              </div>
              {errors?.gender?.type === "required" && (
                <p className="error-text">This field is required</p>
              )}
            </div>
          </div>

          {/* <div className="bottom-fields">
                   <p>Already youro member? <span>Login</span></p>      
		           </div>
                 
		            <div className="button-container">
                   <button className="next-button">Next</button>
                </div> */}
        </div>
      </div>
      <div
        style={{
          width: "50%",
          margin: "0px auto 10px auto",
          paddingTop: "0px",
        }}
      >
        <div
          className="required-fields"
          style={{ justifyContent: "flex-between" }}
        >
          <div
            className="myself-label"
            style={{ width: "48%", marginTop: "0px" }}
          >
            <p>
              Already youro member?{" "}
              <span
                onClick={() => navigate("/login")}
                className="color-secondary"
                style={{ cursor: "pointer" }}
              >
                <u>Login</u>
              </span>{" "}
            </p>
          </div>
          {/*<div style={{position: "relative"}}>*/}
          {/*<div*/}
          {/*    style={{*/}
          {/*      position: "relative",*/}
          {/*      width: "250px",*/}
          {/*      // top: "10px",*/}
          {/*      left: "20px",*/}
          {/*      right: "0px",*/}
          {/*      // fontSize: "12px",*/}
          {/*      // padding: "10px 5px",*/}
          {/*    }} //changes by nandu*/}
          {/*    className="btn-filled"*/}
          {/*    onClick={() => setOpen(true)}*/}
          {/*  >*/}
          {/*    Begin your free Evaluation here*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div
            className="myself-label"
            style={{ width: "45%", position: "relative", bottom: "10px" }} //changes by nandu
          >
            <button
              className="next-button btn-filled"
              onClick={handleSubmit(onsubmit)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      {open && (
        <IntakeForm email={props.data.email} open={open} setOpen={setOpen} /> //changes done by nandu
      )}
    </form>
  );
};

export default Patientaddress;
